import { ValidatorFn, Validators } from '@angular/forms';
import { ConsumeProduct } from '../../core/api/products/entities/product-action.entity';
import { ProductActiveStockItem } from '../../core/api/products/entities/product-active-stock-item.entity';
import { QuantityUnit } from '../../core/api/quantity-units/entities/quantity-unit.entity';
import { positive } from '../form-control-options.constants';
import { QuickActionConsumeFormControls } from '../form-controls/quick-action.form-controls';
import { QuickActionForm } from './quick-action.form';

export class QuickActionConsumeForm extends QuickActionForm<QuickActionConsumeFormControls> {
  formGroup = this.createFormGroup(QuickActionConsumeFormControls);

  public get amountHint(): string | undefined {
    const currentStock = this.product?.activeStockAmount || 0;
    const newAmount = currentStock - this.amount;
    return `${currentStock} → ${newAmount} ${this.quantityUnit?.namePlural}`;
  }

  public get productAction(): ConsumeProduct {
    const productAction: ConsumeProduct = {
      amount: this.amount,
      productId: this.product!.id,
      spoiled: this.controls.spoiled.value!,
    };

    if (this.controls.stockItem.value) {
      productAction.stockItemId = this.controls.stockItem.value.id;
    }

    return productAction;
  }

  public get quantityUnit(): QuantityUnit | undefined {
    return this.product?.quantityUnitStock;
  }

  public override canSelectStockItem(stockItem: ProductActiveStockItem): boolean {
    return stockItem.amount > 0;
  }

  public setAmountToMax(): void {
    if (this.product) {
      if (this.controls.stockItem.value) {
        this.controls.amount.setValue(this.controls.stockItem.value.amount);
      } else {
        this.controls.amount.setValue(this.product.activeStockAmount);
      }
    }
  }

  protected setChangeListeners(): void {
    this.controls.stockItem.valueChanges.subscribe(stockEntry => {
      let maxAmount = this.product?.activeStockAmount || 0;

      if (stockEntry) {
        maxAmount = stockEntry.amount;
      }

      this.controls.amount.setValidators([Validators.required, Validators.min(0.000001), Validators.max(maxAmount)]);
      this.controls.amount.setValue(this.product?.barcode?.amount || 1);

      this.controls.amount.updateValueAndValidity();
    });
  }

  protected setInitialValues(): void {
    this.controls.amount.setValidators([
      ...(positive.validators as ValidatorFn[]),
      Validators.max(this.product?.activeStockAmount || 0),
    ]);
  }
}
